
/**
 * @class draw2d.geo.PositionConstants
 * Static values for point orientation.
 * 
 */
import draw2d from '../packages';


draw2d.geo.PositionConstants=function()
{
};

draw2d.geo.PositionConstants.NORTH =  1;
draw2d.geo.PositionConstants.SOUTH =  4;
draw2d.geo.PositionConstants.WEST  =  8;
draw2d.geo.PositionConstants.EAST  = 16;
